import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { EMPTY, lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SsoResolver implements Resolve<any> {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  async resolve(route: ActivatedRouteSnapshot): Promise<any> {
    const id = route.paramMap.get('id');

    if (!id) {
      this.router.navigate(['/sign-in']);
      return;
    }

    try {
      const res: any = await lastValueFrom(this.authService.sso(id));
      console.log(res);
      if (res?.token) {
        localStorage.setItem('accessToken', res.token);
        localStorage.setItem('access_token', res.token);

        await lastValueFrom(this.authService.setUserValue());
      }

      this.router.navigate(['/dashboards']);
    } catch (e) {
      console.log(e);
      this.router.navigate(['/sign-in']);
    }

    return EMPTY;
  }
}
